import { render, staticRenderFns } from "./compare_periods.vue?vue&type=template&id=65811cf4&lang=pug&"
import script from "./compare_periods.vue?vue&type=script&lang=coffee&"
export * from "./compare_periods.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports